import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=ed06cbb8&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=ed06cbb8&prod&lang=scss&scoped=true"
import style1 from "./detail.vue?vue&type=style&index=1&id=ed06cbb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed06cbb8",
  null
  
)

export default component.exports